<template>
  <div class="operateLogData">
    <div class="col-12 row text-center mx-0 table-responsive" style="">
      <b-table
        :items="operateLogDataItem"
        :fields="operateLogDataFields"
        sticky-header="240px"
        :no-border-collapse="true"
        :class="{
          'operateLogData-table-detail': operateLogTableStyle == '',
          'machStatus-components-table':
            operateLogTableStyle == 'machStatus-components-table',
        }"
        class="operateLogData-table-detail-select"
      >
        <template #cell(status)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["status"] }}</b>
          </template>
          <template v-else>{{ row.item["status"] }}</template>
        </template>
        <template #cell(alarmCode)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["alarmCode"] }}</b>
          </template>
          <template v-else>{{ row.item["alarmCode"] }}</template>
        </template>
        <template #cell(alarmDetail)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["alarmDetail"] }}</b>
          </template>
          <template v-else>{{ row.item["alarmDetail"] }}</template>
        </template>
        <template #cell(startTime)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["startTime"] }}</b>
          </template>
          <template v-else>{{ row.item["startTime"] }}</template>
        </template>
        <template #cell(endTime)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["endTime"] }}</b>
          </template>
          <template v-else>{{ row.item["endTime"] }}</template>
        </template>
        <template #cell(durationTime)="row">
          <template v-if="row.item['alarmCode'] != '' && row.item['alarmCode'].indexOf('_2_') != -1 && row.item['警報'] == '警報'">
            <b style="color: red">{{ row.item["durationTime"] }}</b>
          </template>
          <template v-else>{{ row.item["durationTime"] }}</template>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "operateLogData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      operateLogDataFields: "operateLogData/get_operateLogDataFields",
      operateLogDataItem: "operateLogData/get_operateLogDataItem",
      operateLogTableStyle: "operateLogData/get_operateLogTableStyle",
    }),
  },
};
</script>

<style>
</style>
<style lang="scss">
.operateLogData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.operateLogData-table-detail th,
.operateLogData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.operateLogData-table-detail td {
  font-size: 1rem;
}
.operateLogData-table-detail th:first-child,
.operateLogData-table-detail td:first-child {
  border-left: 1px solid;
}
.operateLogData-table-detail-select tr th:nth-child(1),
.operateLogData-table-detail-select tr td:nth-child(1) {
  width: 80px;
  min-width: 80px;
}
.operateLogData-table-detail-select tr th:nth-child(2),
.operateLogData-table-detail-select tr td:nth-child(2) {
  width: 110px;
  min-width: 110px;
  max-width: 110px;
  white-space: pre-line;
}
.operateLogData-table-detail-select tr th:nth-child(3),
.operateLogData-table-detail-select tr td:nth-child(3) {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  white-space: pre-line;
}
.operateLogData-table-detail-select tr th:nth-child(4),
.operateLogData-table-detail-select tr td:nth-child(4) {
  width: 210px;
  min-width: 210px;
}
.operateLogData-table-detail-select tr th:nth-child(5),
.operateLogData-table-detail-select tr td:nth-child(5) {
  width: 210px;
  min-width: 210px;
}
.operateLogData-table-detail-select tr th:nth-child(6),
.operateLogData-table-detail-select tr td:nth-child(6) {
  width: 110px;
  min-width: 110px;
}
.operateLogData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.operateLogData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.operateLogData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/operateLogData.vue